import { BasicScreen } from "./BasicScreen";
/**
 * Created with IntelliJ IDEA.
 * User: Aaron
 * Date: 24.07.12
 * Time: 14:19
 * To change this template use File | Settings | File Templates.
 */


import { BasicController } from "../../controller/BasicController";
import { IdleScreenEvent } from "../../event/IdleScreenEvent";
import { SimplePreloadAnim } from "../preloader/SimplePreloadAnim";

import Sprite = createjs.Sprite;
import Event = createjs.Event;
import Container = createjs.Container;
import Shape = createjs.Shape;

export class BasicIdleScreen extends BasicScreen {
    public static NAME: string = "BasicIdleScreen";

    private bg: Shape;
    private idleScreenBackground: Container;
    private loadingAnimation: SimplePreloadAnim;

    constructor(idleHolderLayer: Container) {
        super(idleHolderLayer);
    }

    private drawBackground(): void {
        this.bg.alpha = 0.5;
        this.bg.graphics
            .clear()
            .beginFill("#000000")
            .drawRect(0, 0, this.disp.stage.stageWidth, this.disp.stage.stageHeight)
            .endFill();

        this.idleScreenBackground.addChildAt(this.bg, 0);
    }

    protected applyProperties(): void {
        this.idleScreenBackground = new Container();
        this.idleScreen.addChild(this.idleScreenBackground);

        this.loadingAnimation = new SimplePreloadAnim();

        BasicController.getInstance().addEventListener(IdleScreenEvent.SHOW, this.bindFunction(this.showScreen));
        BasicController.getInstance().addEventListener(IdleScreenEvent.HIDE, this.bindFunction(this.hideScreen));
    }

    public show(): void {
        super.show();
        this.idleScreenBackground.addChild(this.loadingAnimation);
    }

    public hide(): void {
        if (this.idleScreenBackground && this.idleScreenBackground.contains(this.loadingAnimation)) {
            this.idleScreenBackground.removeChild(this.loadingAnimation);
        }
        super.hide();
    }

    protected init(): void {
        super.init();
    }

    private hideScreen(event: IdleScreenEvent): void {
        //			trace(NAME + " hideScreen()");
        this.hide();
    };


    protected onResize(event: Event): void {
        this.drawBackground();
    };

    public showScreen(e: IdleScreenEvent): void {
        //			trace(NAME + " showScreen()");
        this.drawBackground();
        this.show();
    };

    private get idleScreen(): Container {
        return (<Container>this.disp);
    }
}


